const translations = {
    HEADER_BAR_MY_PASSES: {
        description: 'Title on the top navigation menu so the user may manage their passes.',
        primaryValue: 'MY PASSES',
        stringKey: 'HEADER_BAR_MY_PASSES',
    },
    HEADER_BAR_MY_ACCOUNT: {
        description: 'Title on the top navigation menu so the user may manage their account.',
        primaryValue: 'MY ACCOUNT',
        stringKey: 'HEADER_BAR_MY_ACCOUNT',
    },
    HEADER_BAR_FAMILY: {
        description: 'Title on the top navigation menu so the user may manage their family.',
        primaryValue: 'FAMILY',
        stringKey: 'HEADER_BAR_FAMILY',
    },
    HEADER_BAR_MY_ACCESS: {
        description: 'Title on the top navigation menu so the user may manage their access.',
        primaryValue: 'MY ACCESS',
        stringKey: 'HEADER_BAR_MY_ACCESS',
    },
    HEADER_BAR_APPROVALS: {
        description: 'Title on the top navigation menu so the user may manage their approvals.',
        primaryValue: 'APPROVALS',
        stringKey: 'HEADER_BAR_APPROVALS',
    },
    HEADER_BAR_MANAGE: {
        description: "Title on the top navigation menu so the user may manage settings.",
        primaryValue: 'MANAGE',
        stringKey: 'HEADER_BAR_MANAGE',
    }
};

export default translations;